import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import { getClassName } from '../../utils/ui/classes';
const defaultClassName = {
    flex: true,
    'justify-between': true,
    'bg-blue-lightest': true,
    'bg-border-t-4': true,
    'border-solid': true,
    'text-blue-dark': true,
    'p-3': true,
    'w-full': true,
};
class ProTip extends Component {
    constructor() {
        super(...arguments);
        this.handleClose = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.onClose();
        };
    }
    render() {
        const { children, message, className, t, dataTestId } = this.props;
        const finalClassName = getClassName(Object.assign({}, defaultClassName), className);
        return ((React.createElement("div", { "data-testid": dataTestId, className: finalClassName },
            React.createElement("div", { "data-testid": "div-9e870251", className: "flex protip-wrapper" },
                React.createElement("i", { "data-testid": "i-ef7daf70", className: "fa fa-lightbulb-o mr-3 mt-1 fa-2x" }),
                React.createElement("div", { "data-testid": "div-d8671807", className: "flex flex-col mb-0" },
                    React.createElement("strong", { "data-testid": "strong-8cfff37c", className: "mt-1 mr-2 mb-2" }, t('PRO_TIP_WITH_EXCLAIMATION')),
                    React.createElement("p", { "data-testid": "p-7a96df00", className: "text-blue mb-0" }, children || message))),
            this.props.onClose && (React.createElement("a", { "data-testid": "a-4fc14012", href: "#", className: "text-lg", onClick: this.handleClose },
                React.createElement("svg", { "data-testid": "svg-bf7ab8bf", className: "fill-current h-6 w-6", role: "button", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
                    React.createElement("title", { "data-testid": "title-89d7c951" }, titleize(t('CLOSE'))),
                    React.createElement("path", { "data-testid": "path-a8a4b55d", d: "M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" })))))));
    }
}
ProTip.propTypes = {
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
PropTypes.defaultProps = {
    className: {},
};
export default withTranslation()(ProTip);
